export default __webpack_public_path__ + "00cb6aa.png";